import type {
  ApiKeyEditFormData,
  ApiKeyFormData,
} from "@/routes/_app/-secure-llm/-queries";
import { api } from "@/lib/http";

function createLlmApiKey(data: ApiKeyFormData) {
  return api.raw.post("api/v1/llm/api-keys", { json: data }).json();
}

function updateLlmApiKey(id: string, data: ApiKeyEditFormData) {
  return api.raw.put(`api/v1/llm/api-keys/${id}`, { json: data }).json();
}

function deleteLlmApiKey(id: string) {
  return api.raw.delete(`api/v1/llm/api-keys/${id}`);
}

export default {
  createLlmApiKey,
  updateLlmApiKey,
  deleteLlmApiKey,
};
